import { DiscountTargetType, DiscountType } from "@/lib/gql/__generated__/graphql";

import { discountTargetTypeConverter, omittedPriceSettingConverter } from "./base-converter";

import type { LongTermStay } from "..";
import type { RowData } from "../../../discount-table";

/**
 * 宿泊数の PriceSetting へのデータ変換
 */
const smallestNightsForPriceSettingConverter = (
	currentSmallestNights: number,
	nextSmallestNights: number,
	index: number,
	length: number,
) => {
	return (
		currentSmallestNights +
		(index < length - 1 && nextSmallestNights - 1 !== currentSmallestNights ? ` ~ ${nextSmallestNights - 1}` : "") +
		(index === length - 1 ? "泊目以降" : "泊目")
	);
};
/**
 * DiscountType = Ratio の PriceSetting へのデータ変換
 */
const discountTypeRatioForPriceSettingConverter = (ratio: number) => `通常料金から${ratio}%割引`;
/**
 * DiscountType = Static の PriceSetting へのデータ変換
 */
const discountTypeStaticForPriceSettingConverter = (staticPrice: number, staticTargetType: DiscountTargetType) => {
	const staticTargetTypeDisplayText = discountTargetTypeConverter(staticTargetType);
	return `${staticTargetTypeDisplayText}ごとに${staticPrice.toLocaleString()}円引き`;
};

/**
 * LongTermStayDiscount の行データを生成する
 */
export const longTermStayRowsDataConverter = (longTermStayList: LongTermStay): Array<RowData> => {
	return longTermStayList.map((discount) => {
		const discountPriceTotalLimitAmount = discount.discountPriceTotalLimit?.amount ?? undefined;
		const convertedBasic = omittedPriceSettingConverter(
			discount.discountID,
			discount.name,
			discount.discountCode,
			discount.discountPriceTotal.amount,
			discount.inSale,
			discountPriceTotalLimitAmount,
		);

		const longTermStayDiscountList = discount.longTermStayDiscountObject;
		const longTermStayDiscountListLength = longTermStayDiscountList.length;
		const convertedPriceSetting = longTermStayDiscountList
			.map((longTermStayDiscount, index) => {
				const currentSmallestNights = longTermStayDiscount.includeSmallestNights;
				const nextSmallestNights = longTermStayDiscountList[index + 1]?.includeSmallestNights ?? 0;
				const discountRatio = longTermStayDiscount.ratio ?? 0;
				const longTermDiscountStaticAmount = longTermStayDiscount.static?.amount ?? 0;
				return (
					smallestNightsForPriceSettingConverter(
						currentSmallestNights,
						nextSmallestNights,
						index,
						longTermStayDiscountListLength,
					) +
					" " +
					(longTermStayDiscount.discountType === DiscountType.Ratio
						? discountTypeRatioForPriceSettingConverter(discountRatio)
						: discountTypeStaticForPriceSettingConverter(
								longTermDiscountStaticAmount,
								DiscountTargetType.PerGroup, // @todo Query が修正された後にメンバを参照する
							))
				);
			})
			.join("\n");

		return {
			...convertedBasic,
			priceSetting: convertedPriceSetting,
		} satisfies RowData;
	}) satisfies Array<RowData>;
};
